import { Button, Checkbox } from 'antd';
import React, { useState } from 'react';
import { DisableReportingOfInfoStore } from '../../../../../../../model/DeviceAdminModel';
import { useStoreDispatch, useStoreSelector } from '../../../../../../../store';
import { ControllerReporting } from '../../../../../../../store/deviceControl/controller/actionTypes';
import { setControllerReportingSetupAction } from '../../../../../../../store/deviceControl/controller/actions';
import { selectDisableReportingOfInfo } from '../../../../../../../store/deviceControl/controller/selectors';
import { AdvanceReportingSetup } from '../AdvanceReportingSetup/AdvanceReportingSetup';
import styles from '../reporting.module.scss';

const DisableReportingOf: React.FC = () => {
	//#region state management variables
	const dispatch = useStoreDispatch();
	const [showAdvancedReportingModal, setShowAdvancedReportingModal] = useState<boolean>(false);
	const disableReportingOfInfo: DisableReportingOfInfoStore = useStoreSelector<DisableReportingOfInfoStore>(selectDisableReportingOfInfo);
	//#endregion

	const handleChangeControllerReportingSetup = (value: ControllerReporting) => {
		dispatch(
			setControllerReportingSetupAction({
				...value,
			})
		);
	};

	return (
		<div className={styles.disableReportingOf}>
			<div className={styles.disableReportingOfCheckboxes}>
				<div>
					<Checkbox
						id='controllerReportingDisableDailyCheckbox'
						onChange={e => handleChangeControllerReportingSetup({ DisableReportingDailyMidnight: e.target.checked })}
						checked={disableReportingOfInfo.dailyMidnightReport}>
						<div>{_('DailyMidnightReport')}</div>
					</Checkbox>
				</div>
				<div>
					<Checkbox
						id='controllerReportingDisableInvalidCheckbox'
						onChange={e => handleChangeControllerReportingSetup({ DisableReportingInvalidCodes: e.target.checked })}
						checked={disableReportingOfInfo.invalidCodes}>
						{_('InvalidCodes')}
					</Checkbox>
				</div>
				<div>
					<Checkbox
						id='controllerReportingDisableRelayCheckbox'
						onChange={e => handleChangeControllerReportingSetup({ DisableReportingRelayStateChanges: e.target.checked })}
						checked={disableReportingOfInfo.relayStateChanges}>
						{_('RelayStateChanges')}
					</Checkbox>
				</div>
				<div>
					<Checkbox
						id='controllerReportingDisableTimeZoneStateCheckbox'
						onChange={e => handleChangeControllerReportingSetup({ DisableReportingTimeZoneStateChanges: e.target.checked })}
						checked={disableReportingOfInfo.timeZoneStateChanges}>
						{_('TimeZoneStateChanges')}
					</Checkbox>
				</div>
				<div>
					<Checkbox
						id='controllerReportingDisableTimeZoneRelayCheckbox'
						onChange={e => handleChangeControllerReportingSetup({ DisableReportingTimeZoneDrivenRelay: e.target.checked })}
						checked={disableReportingOfInfo.tzDrivenRelayStateChanges}>
						{_('TZDrivenRelayStateChanges')}
					</Checkbox>
				</div>
				<div>
					<Checkbox
						id='controllerReportingDisableTimeZoneInputCheckbox'
						onChange={e => handleChangeControllerReportingSetup({ DisableReportingTimeZoneDrivenInput: e.target.checked })}
						checked={disableReportingOfInfo.tzDrivenInputMaskingChanges}>
						{_('TZDrivenInputMaskingChanges')}
					</Checkbox>
				</div>
			</div>
			<div className={styles.disableReportingOfButtonContainer}>
				<Button
					id='controllerReportingAdvancedReportingButton'
					className={styles.disableReportingOfButton}
					type='primary'
					onClick={() => setShowAdvancedReportingModal(true)}>
					{_('AdvancedReportingSetups')}
				</Button>
			</div>
			{showAdvancedReportingModal && <AdvanceReportingSetup handleOnHideModal={() => setShowAdvancedReportingModal(false)} />}
		</div>
	);
};

export { DisableReportingOf };
